const actions = {
  setButtonActive(context, payload) {
    context.commit("mutationButtonActive", payload);
  },

  setShowDescFooter(context, payload) {
    context.commit("mutationShowDescFooter", payload);
  },

  setFooterTemplate(context, payload) {
    context.commit("mutationFooterTemplate", payload);
  },

  setHeaderIconLeft(context, payload) {
    context.commit("mutationHeaderIconLeft", payload);
  },

  setHeaderIconRight(context, payload) {
    context.commit("mutationHeaderIconRight", payload);
  },

  setSearchBar(context, payload) {
    context.commit("mutationSearchBar", payload);
  },

  setSearchBarPlaceholder(context, payload) {
    context.commit("mutationSearchBarPlaceholder", payload);
  },

  setSearchBarTriggered(context, payload) {
    context.commit("mutationSearchBarTriggered", payload);
  },

  setSearchBarCondition(context, payload) {
    context.commit("mutationSearchBarCondition", payload);
  },

  setMobileBodyHeight(context, payload) {
    context.commit("mutationMobileBodyHeight", payload);
  },

  setBackLink(context, payload) {
    context.commit("mutationBackLink", payload);
  },
};

export default actions;
